/* eslint-disable no-underscore-dangle */
import {
  createStore,
  combineReducers,
  applyMiddleware,
} from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import * as reducers from '../reducers';

const composeEnhancers = composeWithDevTools({
  // options like actionSanitizer, stateSanitizer
});
const appReducer = combineReducers({ ...reducers });
const store = createStore(
  appReducer,
  composeEnhancers(applyMiddleware(thunk)),
);

export default store;
